import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Observable } from 'rxjs';

import { CoachSettingsBiographyController } from './coach-settings-biography.controller';
import { CoachSettingsBiographyStore } from './coach-settings-biography.store';

@Component({
	selector: 'spr-settings-biography',
	templateUrl: './coach-settings-biography.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachSettingsBiographyStore, CoachSettingsBiographyController],
	host: {
		class: 'flex items-stretch flex-col',
	},
})
export class CoachSettingsBiographyComponent {
	public form: FormGroup;
	public editor = ClassicEditor;
	public isSaving$: Observable<boolean>;
	public editorConfig$: Observable<any>;

	constructor(private _controller: CoachSettingsBiographyController) {
		this.editorConfig$ = _controller.editorConfig$;
		this.isSaving$ = _controller.isSaving$;
		this.form = _controller.form as FormGroup;
	}

	public onUpdateClick() {
		this._controller.updateBiography();
	}
}
